import { ColumnDef } from '@tanstack/react-table';
import { SortableHeader, TruncatedCell } from '@/components';
import { MedicationDataRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DASH } from '../../utils/displayValues';
import { DocumentSource, DocumentType } from '../../viewer';

export const createMedicationsColumns =
  (): ColumnDef<MedicationDataRecord>[] => [
    {
      accessorKey: 'name',
      header: 'Medication',
      cell: ({ row }) =>
        row.original.name === null ? (
          DASH
        ) : row.original.name ? (
          <TruncatedCell text={row.original.name} className="font-medium" />
        ) : (
          'No data available'
        ),
    },
    {
      accessorKey: 'dosage',
      header: 'Dosage',
      cell: ({ row }) => row.original.dosage || 'No data available',
    },
    {
      id: 'sourceType',
      accessorFn: (row) => row.sourceTypes,
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Sources</SortableHeader>
      ),
      cell: ({ row }) => {
        const sourceTypes = row.original.sourceTypes ?? [];
        if (sourceTypes.length === 0) return 'No data available';
        return sourceTypes.join(', ');
      },
    },
    {
      id: 'actions',
      enableSorting: false,
      header: '',
      cell: ({ row }) => {
        const firstSourceType = row.original.sourceTypes[0];
        return (
          <div className="flex items-center justify-end">
            <PatientDocumentViewButton
              disabled={!firstSourceType}
              documentKey={{
                source: DocumentSource.MEDICAL_DATA,
                type: DocumentType.MEDICATIONS,
                medicationId: row.original.id,
                sourceType: firstSourceType,
                name: row.original.name === null ? DASH : row.original.name,
              }}
            />
          </div>
        );
      },
    },
  ];
